(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/single-ticket.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/single-ticket.js');
"use strict";

const {
  Image
} = svs.content.image_v2;
const {
  useEffect
} = React;
const SingleTicket = _ref => {
  let {
    history,
    voucher = {},
    message,
    toName,
    closed,
    personalGreeting
  } = _ref;
  const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
  const {
    reactPayfooterCustomerServiceTexts
  } = svs.ticket_gifts.constants;
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const {
    bubbleInfoHeader
  } = svs.ticket_gifts.functions;
  const {
    img
  } = voucher;
  const handlePlayClick = e => {
    if (voucher.availableOnline) {
      e && e.preventDefault();
      history && history.push("".concat(history.location.pathname, "/spela/").concat(voucher.giftCode));
    } else {
      var _svs$ticket_gifts$gam;
      const type = (_svs$ticket_gifts$gam = svs.ticket_gifts.games.find(game => game.voucherId === voucher.voucherConfigId)) === null || _svs$ticket_gifts$gam === void 0 ? void 0 : _svs$ticket_gifts$gam.type;
      svs.ticket_gifts.redeem.components.util.showNotAvailableDialog(type, () => history && history.push("../../".concat(voucher.giftCode, "/streckkod")));
    }
  };

  useEffect(() => {
    return () => svs.ticket_gifts.redeem.components.util.hideNotAvailableDialog();
  }, []);
  const payfooterButtons = [{
    primary: true,
    text: 'Skrapa presentlott',
    onClick: handlePlayClick,
    disabled: closed
  }];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-container",
    "data-testid": "single-ticket"
  }, React.createElement("div", {
    className: "single-ticket-bubble-wrapper"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: bubbleInfoHeader(personalGreeting, toName)
  }, message)), img ? React.createElement("div", {
    className: "single-ticket-img-wrapper"
  }, React.createElement(Image, {
    cssSelectors: "single-ticket-img",
    image: img
  })) : React.createElement("div", {
    className: "single-ticket-default-img-wrapper"
  }, React.createElement("img", {
    className: "single-ticket-default-img",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png")
  }))), React.createElement(Payfooter, {
    buttons: payfooterButtons,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.redeem.components.SingleTicket', SingleTicket);

 })(window);